(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-hero-section"] && !Shopify.designMode) return;
  try {
    

const mm = gsap.matchMedia();

// Mobile
mm.add("(max-width: 767px)", () => {
gsap.utils.toArray(".gradient-bar-vertical").forEach((bar) => {
  gsap.fromTo(
    bar,
    {
      scaleX: 0,
      transformOrigin: "left center"
    },
    {
      scaleX: 1,
      duration: 2,
      ease: "power1.inOut",
      scrollTrigger: {
        trigger: bar,
        start: "top 100%",
        once: true
      }
    }
  );
});
});

// Desktop
mm.add("(min-width: 768px)", () => {  
gsap.utils.toArray(".gradient-bar-vertical").forEach((bar) => {
  gsap.fromTo(
    bar,
    {
      scaleY: 0,
      transformOrigin: "bottom center"
    },
    {
      scaleY: 1,
      duration: 2,
      ease: "power1.inOut",
      scrollTrigger: {
        trigger: bar,
        start: "top 100%",
        once: true
      }
    }
  );
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero-section"] && !Shopify.designMode) return;
  try {
    
gsap.registerPlugin(ScrollTrigger);

gsap.to(".sticky-section", {
  y: -200,
  force3D: true,
  ease: "none",
  scrollTrigger: {
    trigger: ".sticky-section",
    start: "top top",
    end: "bottom top",
    pin: true,
    pinSpacing: false,
    scrub: 0.5, // smooth catch-up effect
    invalidateOnRefresh: true
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
